// extracted by mini-css-extract-plugin
export default {"Dot":"styles_Dot__pFlw8","active":"styles_active__mpL95"};